
    import { mapGetters } from "vuex"
    import { logout } from "@/api/auth-data.service"
    import { defineComponent } from "vue"
    import getters from "@/store/getters"
    import LogIn from "./auth/LogIn.vue"

    export default defineComponent({
        props: {

        },
        components: {
            LogIn,

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters(['user', 'isModer', 'isAdmin']),
            left(): number {
                return (this.user?.queriesLimit || 10) - (this.user?.queriesUsed || 0)
            },
        },
        methods: {
            async submit() {
                try {
                    const token = await logout()
                } catch (e) {
                    console.log(e)
                }
            },
        },
    })

    